import PropTypes from 'prop-types'

/*
EXAMPLE:

{
  "id": "1",
}

*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
})
